<template>
  <div>
    <div class="fxCont">
      <div class="headBox">
        <div class="name">打开小程序分享到微信朋友圈</div>
        <div class="iconfont icon-close close" @click="delClick"></div>
      </div>
      <div class="img">
        <img :src="$imgUrl+imgBox" alt="" />
      </div>
      <div class="txt">打开微信，点击底部‘发现’,使用‘扫一扫’</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  props: ["imgBox"],
  created() {},
  methods: {
    delClick() {
      this.$emit("show");
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.fxCont {
  position: fixed;
  top: calc(50vh - 180px);
  left: calc(50vw - 150px);
  background-color: #fff;
  width: 300px;
  border: 1px solid #ebebeb;
  border-radius: 5px;
  .headBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    height: 40px;
    padding: 0 15px;
    .close {
      cursor: pointer;
    }
  }
  .img {
    padding: 25px;
    padding-top: 5px;
    padding-bottom: 15px;
  }
  .txt {
    padding-left: 15px;
    padding-bottom: 15px;
  }
}
</style>
